import { languageTagForUiLocale, type UiLocale } from "./locale";

const DOCUMENT_COPY: Readonly<
  Record<
    UiLocale,
    {
      readonly description: string;
      readonly title: string;
    }
  >
> = {
  ko: {
    title: "반려주식 — 내 종목이 사는 작은 농장",
    description:
      "내 보유 종목이 슬라임으로 살아가는 도트 농장, 반려주식",
  },
  en: {
    title: "Tickerlings — Your portfolio, brought to life",
    description:
      "A playful pixel home where every holding becomes a living Tickerling.",
  },
};

export function applyDocumentUiLocale(
  locale: UiLocale,
  documentTarget: Document | undefined =
    typeof document === "undefined" ? undefined : document,
): void {
  if (!documentTarget) {
    return;
  }
  documentTarget.documentElement.lang = languageTagForUiLocale(locale);
  documentTarget.documentElement.dataset.uiLocale = locale;
  documentTarget.title = DOCUMENT_COPY[locale].title;
  let description = documentTarget.querySelector<HTMLMetaElement>(
    'meta[name="description"]',
  );
  if (!description) {
    description = documentTarget.createElement("meta");
    description.name = "description";
    documentTarget.head.append(description);
  }
  description.content = DOCUMENT_COPY[locale].description;
}
